// components/group/feed/utils/format.js
export function formatCurrency(amount, currency = 'USD') {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: String(currency || 'USD').toUpperCase(),
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${n.toFixed(2)} ${String(currency || 'USD').toUpperCase()}`;
  }
}

export function moneyFromCents(cents) {
  const c = Number(cents || 0) || 0;
  return c / 100;
}

export function formatCurrencyFromCents(cents, currency = 'USD') {
  return formatCurrency(moneyFromCents(cents), currency);
}

export function countLessons(modules) {
  if (!Array.isArray(modules)) return 0;
  return modules.reduce((sum, m) => {
    const lessons = Array.isArray(m?.lessons)
      ? m.lessons
      : Array.isArray(m?.videos)
      ? m.videos
      : Array.isArray(m?.items)
      ? m.items
      : [];
    return sum + lessons.length;
  }, 0);
}

export function totalDurationSeconds(modules) {
  if (!Array.isArray(modules)) return 0;
  let total = 0;

  for (const m of modules) {
    const lessons = Array.isArray(m?.lessons)
      ? m.lessons
      : Array.isArray(m?.videos)
      ? m.videos
      : Array.isArray(m?.items)
      ? m.items
      : [];

    for (const l of lessons) {
      const v =
        l?.duration_sec ??
        l?.duration_seconds ??
        l?.durationSeconds ??
        l?.duration ??
        0;
      total += Number(v || 0) || 0;
    }
  }
  return total;
}

export function formatDuration(seconds) {
  const s = Math.max(0, Number(seconds || 0) || 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = Math.floor(s % 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return `${ss}s`;
}

/**
 * Back-compat helper: if some parts of the UI still call courseAccess(item)
 * We now prefer calling /courses/:id/access, but this makes old code safer.
 */
export function courseAccess(item, accessOverride = null) {
  if (accessOverride) {
    const isFree = !!accessOverride.is_free || Number(accessOverride.price_cents || 0) <= 0;
    const currency = String(accessOverride.currency || 'usd').toUpperCase();
    const price = moneyFromCents(accessOverride.price_cents || 0);
    const isUnlocked = !!accessOverride.has_access || isFree;
    return { isFree, isUnlocked, price, currency };
  }

  const preview = item?.course_preview || null;
  const course = item?.course || item?.course_data || null;

  const isFree =
    !!(preview?.is_free ?? course?.is_free) ||
    Number(preview?.price_cents ?? course?.price_cents ?? 0) <= 0 ||
    Number(course?.price ?? item?.price ?? 0) <= 0;

  const currency = String(preview?.currency ?? course?.currency ?? item?.currency ?? 'usd').toUpperCase();

  const price =
    preview?.price_cents != null
      ? moneyFromCents(preview.price_cents)
      : Number(course?.price ?? item?.price ?? 0) || 0;

  // Without a per-user access call, we can’t know.
  const isUnlocked = !!course?.is_unlocked || !!item?.is_unlocked || isFree;

  return { isFree, isUnlocked, price, currency };
}
